import { useState } from 'react'

// Constants
import { CONST } from '../../../../const/const'
import { UserModel } from '../../../../models/users/user.model'

// Redux
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'

// Services
import { getConvertedData } from '../../../../models/interface.helper'
import {IRiderTeamMember, IUserInterface} from '../../../../models/users/user.interface'
import FirestoreService from '../../../../services/firestoreService'
import { selectProfileData, setProfileDetails } from '../../../../store/user/userSlice'

const useProfileHook = () => {
  // Hooks and vars
  const dispatch = useAppDispatch()
  const profileData = useAppSelector(selectProfileData)

  const [loading, setLoading] = useState(false)

  const getModelledUserDetails = (dataToConvert: any) => {
    return new UserModel({
      ...profileData,
      userNotificationsSettings: profileData?.userNotificationsSettings,
      ...dataToConvert,
    }).toFirestore()
  }

  const updateUserDetails = async (dataToUpdate: any): Promise<{ status: boolean }> => {
    let updateTeamMembers = false
    let mutated: IRiderTeamMember[] = []

    setLoading(true)

    if (dataToUpdate?.hasOwnProperty('userTeamMembers')) {
      updateTeamMembers = true
      mutated = Array.isArray(dataToUpdate?.userTeamMembers) ? dataToUpdate?.userTeamMembers : []
    }

    if (updateTeamMembers) {
      dataToUpdate.userTeamMembers = mutated
    }

    try {
      await FirestoreService.updateItem(
        CONST.DATA.FIRESTORE.LATEST.COLLECTIONS.USERS.NAME,
        profileData?.id || dataToUpdate.id,
        dataToUpdate
      )

      dispatch(
        setProfileDetails(
          getConvertedData({
            ...profileData,
            ...dataToUpdate,
          })
        )
      )

      return { status: true }
    } catch (error) {
      console.error(error, 'error')
      return { status: false }
    } finally {
      setLoading(false)
    }
  }

  const updateStripeConnectDetails = async (
    userStripeAccountId: IUserInterface['userStripeAccountId'],
    userStripeAccountStatus: IUserInterface['userStripeAccountStatus']
  ): Promise<{ status: boolean; error?: any }> => {
    setLoading(true)

    try {
      await updateUserDetails({
        userStripeAccountId: userStripeAccountId ?? null,
        userStripeAccountStatus: userStripeAccountStatus ?? null,
      })

      return { status: true }
    } catch (error) {
      console.error(error, 'error')
      return {
        status: false,
        error,
      }
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    updateUserDetails,
    getModelledUserDetails,
    updateStripeConnectDetails,
  }
}

export default useProfileHook
